import React, { useEffect, useState } from 'react';
import { Dropzone } from '@mantine/dropzone';
import { Group, Text } from '@mantine/core';

import { ReactComponent as OrangePlusImg } from 'assets/images/orangePlusImg.svg';
import { ReactComponent as UploadedIcon } from 'assets/images/uploadedIcon.svg';
import { ErrorToast } from 'services/toasterService';

export default function FileUpload({ multiple, setImage, value }) {
  const [fileName, setFileName] = useState('');

  const dropzoneChildren = () => {
    return (
      <div className='flex flex-col items-center py-2'>
        <OrangePlusImg />
        <p className='text-neutralsGrey pt-2'>
          Drag and drop or browse to choose a file
        </p>
      </div>
    );
  };

  const filesList = (index) => {
    const valueList = [];
    if (index?.length !== 0) {
      // eslint-disable-next-line
      index?.map((each) => {
        valueList?.push(each?.name);
      });
    }

    return valueList;
  };

  const fileSelected = () => (
    <Group
      position='center'
      spacing='xl'
      style={{ minHeight: 90, pointerEvents: 'none' }}
      className='flex flex-col'
    >
      {/* <XlssucessImage /> */}
      <UploadedIcon />
      <div className='-mt-4 text-sm'>
        <Text size='xs' inline className='text-[#828282]'>
          {/* {value[0].name ? value[0].name : fileName} */}
          {filesList(value)?.join(' , ') || fileName}
        </Text>
      </div>
    </Group>
  );

  useEffect(() => {
    if (value && !value[0].name) {
      let companyLogoNameArr = value?.split('/');
      setFileName(companyLogoNameArr?.slice(-1)?.pop());
    }
  }, [value]);

  return (
    <div>
      <Dropzone
        onDrop={(files) => {
          setImage(files);
        }}
        onReject={() => ErrorToast({ text: 'File should be less than 1GB' })}
        // accept={['image/png', 'image/jpeg', 'image/sgv+xml', 'application/pdf']}
        maxSize={1073741824}
        classNames={{
          root: 'border-primary border-opacity-80',
        }}
        multiple={true}
      >
        {!value ? () => dropzoneChildren() : () => fileSelected()}
      </Dropzone>
    </div>
  );
}
